export default __webpack_public_path__ + "ubisoft-playtest-home-banner-desktop.webp";